export class VisitaIncidencia {
    public idcompania:string;
    public idVisita:string;
    public idPunto:string;
    public fecha:Date;
    public motivo:string;
    public longitud:string;
    public latitud:string;
    public estadoIncidente:number;
}
